/**
 * Sueco cart gift options editor.
 *
 * カートの各行に、商品ページと同じギフトオプションUIを出す。
 * 商品ページが /cart/add.js で「追加」するのに対し、
 * こちらは /cart/change.js で既存行の properties を「編集」する。
 *
 * 保存の流れ:
 *   1. /cart.js で行の現在値を取得（画面の値は古い可能性がある）
 *   2. SuecoGiftCore が正規キーで properties 全量を組み立てる
 *   3. /cart/change.js に全量送信（部分更新は不可）
 *   4. cart-gift-sync に付属品行の増減を任せてからリロード
 */
(function () {
  "use strict";

  if (window.__cartGiftEditorLoaded) return;
  window.__cartGiftEditorLoaded = true;

  var SYNC_HEADER = "X-Gift-Sync";

  function core() {
    return window.SuecoGiftCore || null;
  }

  function esc(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function initAll() {
    var c = core();
    if (!c) return;
    var catalog = c.catalog();
    if (!catalog.enabled) return;

    var pending = [];
    document.querySelectorAll("[data-gift-cart-editor]").forEach(function (el) {
      if (el.getAttribute("data-gift-bound") === "true") return;
      // 付属品そのものの行には出さない
      if (
        catalog.productId &&
        String(el.getAttribute("data-line-product-id")) ===
          String(catalog.productId)
      ) {
        return;
      }
      pending.push(el);
    });
    if (pending.length === 0) return;

    // 既存の選択内容は /cart.js を正とする。
    // Liquid の item.properties は [key, value] の配列として出力され、
    // 値の引用符も HTML エスケープされるので、属性からは復元できない。
    fetchCart()
      .then(function (cart) {
        pending.forEach(function (el) {
          var line = findLine(
            cart,
            el.getAttribute("data-line-key"),
            el.getAttribute("data-line-index")
          );
          if (!line) return;
          el.setAttribute("data-gift-bound", "true");
          el.giftLine = line;
          build(el, line);
        });
      })
      .catch(function (err) {
        console.error("[cart-gift-editor] cart load failed:", err);
      });
  }

  function build(el, line) {
    var c = core();
    var properties = (line && line.properties) || {};
    var state = c.stateFromProperties(properties);
    state.noshiWanted = !!state.noshiType && !isSeasonalNoshi(state.noshiVariantId);
    state.cardWanted = !!state.cardLabel;

    var noshiItems = c.itemsOfKind("noshi");
    var bagItems = c.itemsOfKind("bag");
    var cardItems = c.itemsOfKind("card");
    var seasonalNoshiItem = seasonalNoshi();

    if (
      noshiItems.length === 0 &&
      bagItems.length === 0 &&
      cardItems.length === 0 &&
      !seasonalNoshiItem
    ) {
      return;
    }

    var uid = "CartGift-" + (el.getAttribute("data-line-index") || "0");
    el.innerHTML = markup(uid, state, {
      noshi: noshiItems,
      bag: bagItems,
      card: cardItems,
      seasonalNoshi: seasonalNoshiItem
    });
    bind(el, state, uid);
    refresh(el, state);
  }

  function seasonalNoshi() {
    var found = core()
      .catalog()
      .items.filter(function (item) {
        return item.seasonalNoshi === true;
      });
    return found.length ? found[0] : null;
  }

  function isSeasonalNoshi(variantId) {
    var item = seasonalNoshi();
    return !!(item && core().normalizeId(item.id) === core().normalizeId(variantId));
  }

  function optionRow(item, selectedId) {
    var c = core();
    var selected = c.normalizeId(item.id) === c.normalizeId(selectedId);
    return (
      '<li class="gift-options__custom-select-item" role="option"' +
      (selected ? ' aria-selected="true"' : "") +
      ' data-value="' +
      esc(item.label) +
      '" data-variant-id="' +
      esc(item.id) +
      '" data-variant-price="' +
      esc(item.price) +
      '">' +
      (item.image
        ? '<img class="gift-options__custom-select-item-image" src="' +
          esc(item.image) +
          '" alt="' +
          esc(item.label) +
          '" loading="lazy" width="40" height="40">'
        : "") +
      '<span class="gift-options__custom-select-item-text">' +
      '<span class="gift-options__custom-select-item-value">' +
      esc(item.label) +
      "</span></span>" +
      '<span class="gift-options__custom-select-item-price">+' +
      esc(core().formatPriceJPY(item.price)) +
      "</span></li>"
    );
  }

  function markup(uid, state, groups) {
    var c = core();
    var html = "";

    html +=
      '<button type="button" class="gift-options__trigger" data-gift-trigger' +
      ' aria-expanded="false" aria-controls="' +
      uid +
      '-panel" aria-label="ギフトオプション">' +
      '<svg class="gift-options__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
      '<rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8V21"/><path d="M3 12h18"/>' +
      '<path d="M12 8c-1.5-2-4-3-4-3s1.5-2 4 0c2.5-2 4 0 4 0s-2.5 1-4 3"/></svg>' +
      '<span class="gift-options__title">ギフトオプション</span>' +
      '<span class="gift-options__summary" data-gift-summary>未選択</span>' +
      '<svg class="gift-options__caret" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 5l3 3 3-3"/></svg>' +
      "</button>";

    html += '<div class="gift-options__panel" id="' + uid + '-panel" hidden>';

    if (groups.seasonalNoshi) {
      html +=
        '<div class="gift-options__fieldset gift-options__fieldset--simple">' +
        '<label class="gift-options__toggle-label gift-options__toggle-label--with-image">' +
        '<input type="checkbox" class="gift-options__toggle" data-gift-seasonal-noshi' +
        (isSeasonalNoshi(state.noshiVariantId) ? " checked" : "") +
        ' data-variant-id="' +
        esc(groups.seasonalNoshi.id) +
        '" data-variant-label="' +
        esc(groups.seasonalNoshi.label) +
        '" data-fixed-omotegaki="' +
        esc(groups.seasonalNoshi.fixedOmotegaki || "敬老の日") +
        '">' +
        (groups.seasonalNoshi.image
          ? '<img class="gift-options__option-image" src="' +
            esc(groups.seasonalNoshi.image) +
            '" alt="' +
            esc(groups.seasonalNoshi.label) +
            '" loading="lazy" width="40" height="40">'
          : "") +
        '<span class="gift-options__option-copy"><span class="gift-options__option-title">敬老の日のしをつける</span>' +
        '<span class="gift-options__option-help">表書き：敬老の日　名入れできます</span></span>' +
        '<span class="gift-options__price">+' +
        esc(c.formatPriceJPY(groups.seasonalNoshi.price)) +
        "</span></label>" +
        '<div class="gift-options__details" data-gift-details="seasonal-noshi"' +
        (isSeasonalNoshi(state.noshiVariantId) ? "" : " hidden") +
        '><div class="gift-options__field"><label for="' +
        uid +
        '-seasonal-naire">名入れ</label><input type="text" id="' +
        uid +
        '-seasonal-naire" class="gift-options__input" data-gift-seasonal-noshi-naire placeholder="例: 山田太郎" value="' +
        esc(state.naire) +
        '"></div></div></div>';
    }

    if (groups.noshi.length) {
      html +=
        '<fieldset class="gift-options__fieldset"><legend class="gift-options__legend">' +
        '<label class="gift-options__toggle-label">' +
        '<input type="checkbox" class="gift-options__toggle" data-gift-toggle="noshi"' +
        (state.noshiWanted ? " checked" : "") +
        ">" +
        '<span class="gift-options__option-copy"><span class="gift-options__option-title">のしをつける</span>' +
        '<span class="gift-options__option-help">種類・表書きを指定できます</span></span>' +
        '<span class="gift-options__price" data-gift-noshi-price>+' +
        esc(c.formatPriceJPY(groups.noshi[0].price)) +
        "</span></label></legend>" +
        '<div class="gift-options__details" data-gift-details="noshi"' +
        (state.noshiWanted ? "" : " hidden") +
        ">" +
        '<div class="gift-options__field"><label>のしの種類</label>' +
        '<div class="gift-options__custom-select" data-gift-dropdown="noshi">' +
        '<button type="button" class="gift-options__custom-select-btn" data-gift-dropdown-btn>' +
        "<span data-gift-dropdown-label>" +
        esc(state.noshiType || "選択してください") +
        "</span>" +
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 5l3 3 3-3"/></svg>' +
        "</button>" +
        '<ul class="gift-options__custom-select-list" data-gift-dropdown-list hidden>' +
        groups.noshi
          .map(function (item) {
            return optionRow(item, state.noshiVariantId);
          })
          .join("") +
        "</ul></div></div>" +
        '<div class="gift-options__field"><label>表書き</label>' +
        '<div class="gift-options__custom-select" data-gift-dropdown="omotegaki">' +
        '<button type="button" class="gift-options__custom-select-btn" data-gift-dropdown-btn' +
        (state.noshiType ? "" : " disabled") +
        ">" +
        "<span data-gift-dropdown-label>" +
        esc(
          state.omotegaki ||
            (state.noshiType ? "選択してください" : "のしの種類を先に選択してください")
        ) +
        "</span>" +
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 5l3 3 3-3"/></svg>' +
        "</button>" +
        '<ul class="gift-options__custom-select-list" data-gift-dropdown-list hidden></ul>' +
        "</div></div>" +
        '<div class="gift-options__field"><label for="' +
        uid +
        '-naire">名入れ</label>' +
        '<input type="text" id="' +
        uid +
        '-naire" class="gift-options__input" data-gift-naire placeholder="例: 山田太郎" value="' +
        esc(state.naire) +
        '"></div>' +
        "</div></fieldset>";
    }

    if (groups.bag.length) {
      html += '<div class="gift-options__fieldset gift-options__fieldset--simple">';
      groups.bag.forEach(function (item) {
        html +=
          '<label class="gift-options__toggle-label">' +
          '<input type="checkbox" class="gift-options__toggle" data-gift-bag' +
          ' data-variant-id="' +
          esc(item.id) +
          '"' +
          (state.bag ? " checked" : "") +
          ">" +
          '<span class="gift-options__option-copy"><span class="gift-options__option-title">' +
          "紙袋をつける</span></span>" +
          '<span class="gift-options__price">+' +
          esc(c.formatPriceJPY(item.price)) +
          "</span></label>";
      });
      html += "</div>";
    }

    if (groups.card.length) {
      html +=
        '<fieldset class="gift-options__fieldset"><legend class="gift-options__legend">' +
        '<label class="gift-options__toggle-label">' +
        '<input type="checkbox" class="gift-options__toggle" data-gift-toggle="card"' +
        (state.cardWanted ? " checked" : "") +
        ">" +
        '<span class="gift-options__option-copy"><span class="gift-options__option-title">シールをつける</span>' +
        '<span class="gift-options__option-help">シールの種類を指定できます</span></span>' +
        '<span class="gift-options__price">+' +
        esc(c.formatPriceJPY(groups.card[0].price)) +
        "</span></label></legend>" +
        '<div class="gift-options__details" data-gift-details="card"' +
        (state.cardWanted ? "" : " hidden") +
        ">" +
        '<div class="gift-options__field"><label>シールの種類</label>' +
        '<div class="gift-options__custom-select" data-gift-dropdown="card">' +
        '<button type="button" class="gift-options__custom-select-btn" data-gift-dropdown-btn>' +
        "<span data-gift-dropdown-label>" +
        esc(state.cardWanted ? state.cardLabel : "選択してください") +
        "</span>" +
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 5l3 3 3-3"/></svg>' +
        "</button>" +
        '<ul class="gift-options__custom-select-list" data-gift-dropdown-list hidden>' +
        groups.card
          .map(function (item) {
            return optionRow(item, state.cardWanted ? state.cardVariantId : "");
          })
          .join("") +
        "</ul></div></div></div></fieldset>";
    }

    html +=
      '<p class="gift-options__error" data-gift-error hidden role="alert"></p>' +
      '<div class="gift-options__cart-actions">' +
      '<button type="button" class="button gift-options__save" data-gift-save>この商品に反映する</button>' +
      '<button type="button" class="link gift-options__cancel" data-gift-cancel>やめる</button>' +
      "</div>";

    html += "</div>";
    return html;
  }

  function bind(el, state, uid) {
    var c = core();

    var trigger = el.querySelector("[data-gift-trigger]");
    var panel = el.querySelector(".gift-options__panel");

    trigger.addEventListener("click", function () {
      var open = panel.hidden;
      panel.hidden = !open;
      trigger.setAttribute("aria-expanded", String(open));
    });

    el.querySelectorAll("[data-gift-toggle]").forEach(function (toggle) {
      toggle.addEventListener("change", function () {
        var kind = toggle.getAttribute("data-gift-toggle");
        var details = el.querySelector('[data-gift-details="' + kind + '"]');
        if (details) details.hidden = !toggle.checked;

        if (kind === "noshi") {
          state.noshiWanted = toggle.checked;
          if (toggle.checked) clearSeasonalNoshi(el, state);
          if (!toggle.checked) {
            state.noshiType = "";
            state.noshiVariantId = "";
            state.omotegaki = "";
            state.naire = "";
            resetDropdown(el, "noshi", "選択してください");
            resetDropdown(el, "omotegaki", "のしの種類を先に選択してください", true);
            var naire = el.querySelector("[data-gift-naire]");
            if (naire) naire.value = "";
          }
        }

        if (kind === "card") {
          state.cardWanted = toggle.checked;
          if (!toggle.checked) {
            state.cardLabel = "";
            state.cardVariantId = "";
            resetDropdown(el, "card", "選択してください");
          }
        }
        refresh(el, state);
      });
    });

    var seasonalNoshiToggle = el.querySelector("[data-gift-seasonal-noshi]");
    if (seasonalNoshiToggle) {
      seasonalNoshiToggle.addEventListener("change", function () {
        var seasonalDetails = el.querySelector(
          '[data-gift-details="seasonal-noshi"]',
        );
        if (seasonalDetails) seasonalDetails.hidden = !seasonalNoshiToggle.checked;
        if (seasonalNoshiToggle.checked) {
          var noshiToggle = el.querySelector('[data-gift-toggle="noshi"]');
          if (noshiToggle && noshiToggle.checked) {
            noshiToggle.checked = false;
            var details = el.querySelector('[data-gift-details="noshi"]');
            if (details) details.hidden = true;
          }
          state.noshiWanted = false;
          state.noshiType = seasonalNoshiToggle.getAttribute("data-variant-label") || "敬老の日";
          state.noshiVariantId = c.normalizeId(
            seasonalNoshiToggle.getAttribute("data-variant-id")
          );
          state.omotegaki =
            seasonalNoshiToggle.getAttribute("data-fixed-omotegaki") || "敬老の日";
        } else {
          state.noshiWanted = false;
          state.noshiType = "";
          state.noshiVariantId = "";
          state.omotegaki = "";
          state.naire = "";
        }
        refresh(el, state);
      });
    }

    el.querySelectorAll("[data-gift-bag]").forEach(function (toggle) {
      toggle.addEventListener("change", function () {
        state.bag = toggle.checked;
        state.bagVariantId = toggle.checked
          ? c.normalizeId(toggle.getAttribute("data-variant-id"))
          : "";
        refresh(el, state);
      });
    });

    el.querySelectorAll("[data-gift-dropdown]").forEach(function (dropdown) {
      var kind = dropdown.getAttribute("data-gift-dropdown");
      var btn = dropdown.querySelector("[data-gift-dropdown-btn]");
      var list = dropdown.querySelector("[data-gift-dropdown-list]");

      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        var open = list.hidden;
        closeAllDropdowns(el);
        list.hidden = !open;
      });

      list.addEventListener("click", function (event) {
        var li = event.target.closest(".gift-options__custom-select-item");
        if (!li || !list.contains(li)) return;
        selectOption(el, state, kind, li);
      });
    });

    document.addEventListener("click", function (event) {
      if (!el.contains(event.target)) closeAllDropdowns(el);
    });

    var naireInput = el.querySelector("[data-gift-naire]");
    if (naireInput) {
      naireInput.addEventListener("input", function () {
        state.naire = naireInput.value;
      });
    }

    var seasonalNaireInput = el.querySelector("[data-gift-seasonal-noshi-naire]");
    if (seasonalNaireInput) {
      seasonalNaireInput.addEventListener("input", function () {
        state.naire = seasonalNaireInput.value;
      });
    }

    el.querySelector("[data-gift-cancel]").addEventListener("click", function () {
      panel.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      build(el, el.giftLine); // 元の値に戻す
    });

    el.querySelector("[data-gift-save]").addEventListener("click", function () {
      save(el, state);
    });
  }

  function selectOption(el, state, kind, li) {
    var c = core();
    var value = li.getAttribute("data-value") || "";
    var variantId = c.normalizeId(li.getAttribute("data-variant-id"));

    if (kind === "noshi") {
      clearSeasonalNoshi(el, state);
      state.noshiType = value;
      state.noshiVariantId = variantId;
      state.omotegaki = "";
      buildOmotegakiList(el, state, value);
    } else if (kind === "omotegaki") {
      state.omotegaki = value;
    } else if (kind === "card") {
      state.cardLabel = value;
      state.cardVariantId = variantId;
      state.cardWanted = true;
    }

    var dropdown = el.querySelector('[data-gift-dropdown="' + kind + '"]');
    var label = dropdown.querySelector("[data-gift-dropdown-label]");
    if (label) label.textContent = value;
    dropdown.querySelectorAll("li").forEach(function (item) {
      item.removeAttribute("aria-selected");
    });
    li.setAttribute("aria-selected", "true");
    dropdown.querySelector("[data-gift-dropdown-list]").hidden = true;

    refresh(el, state);
  }

  function buildOmotegakiList(el, state, noshiType) {
    var dropdown = el.querySelector('[data-gift-dropdown="omotegaki"]');
    if (!dropdown) return;
    var list = dropdown.querySelector("[data-gift-dropdown-list]");
    var btn = dropdown.querySelector("[data-gift-dropdown-btn]");
    var label = dropdown.querySelector("[data-gift-dropdown-label]");
    var options = core().omotegakiFor(noshiType);

    list.innerHTML = options
      .map(function (option) {
        return (
          '<li class="gift-options__custom-select-item" role="option" data-value="' +
          esc(option.value) +
          '"><span class="gift-options__custom-select-item-value">' +
          esc(option.value) +
          '</span><span class="gift-options__custom-select-item-desc">（' +
          esc(option.desc) +
          "）</span></li>"
        );
      })
      .join("");
    list.hidden = true;
    btn.disabled = false;
    label.textContent = options.length ? "選択してください" : "表書きを入力してください";
  }

  function resetDropdown(el, kind, labelText, disable) {
    var dropdown = el.querySelector('[data-gift-dropdown="' + kind + '"]');
    if (!dropdown) return;
    var label = dropdown.querySelector("[data-gift-dropdown-label]");
    var list = dropdown.querySelector("[data-gift-dropdown-list]");
    var btn = dropdown.querySelector("[data-gift-dropdown-btn]");
    if (label) label.textContent = labelText;
    if (list) {
      list.hidden = true;
      list.querySelectorAll("li").forEach(function (item) {
        item.removeAttribute("aria-selected");
      });
    }
    if (btn && disable) btn.disabled = true;
  }

  function clearSeasonalNoshi(el, state) {
    var toggle = el.querySelector("[data-gift-seasonal-noshi]");
    if (!toggle || !toggle.checked) return;
    toggle.checked = false;
    var details = el.querySelector('[data-gift-details="seasonal-noshi"]');
    if (details) details.hidden = true;
    if (isSeasonalNoshi(state.noshiVariantId)) {
      state.noshiType = "";
      state.noshiVariantId = "";
      state.omotegaki = "";
      state.naire = "";
    }
  }

  function closeAllDropdowns(el) {
    el.querySelectorAll("[data-gift-dropdown-list]").forEach(function (list) {
      list.hidden = true;
    });
  }

  function refresh(el, state) {
    var summary = el.querySelector("[data-gift-summary]");
    if (summary) summary.textContent = core().summarize(state).text;
  }

  function showError(el, message) {
    var box = el.querySelector("[data-gift-error]");
    if (!box) return;
    if (!message) {
      box.hidden = true;
      box.textContent = "";
      return;
    }
    box.hidden = false;
    box.textContent = message;
  }

  function setBusy(el, busy) {
    el.classList.toggle("gift-options-wrapper--busy", busy);
    el.querySelectorAll("button, input").forEach(function (control) {
      control.disabled = busy;
    });
  }

  function save(el, state) {
    var c = core();
    var message = c.validate(state);
    if (message) {
      showError(el, message);
      return;
    }
    showError(el, "");
    setBusy(el, true);

    var key = el.getAttribute("data-line-key");

    fetchCart()
      .then(function (cart) {
        var line = findLine(cart, key, el.getAttribute("data-line-index"));
        if (!line) throw new Error("カートの行が見つかりませんでした。ページを再読み込みしてください。");

        var properties = c.propertiesFromState(state, line.properties || {});
        return postChange({
          id: line.key,
          quantity: line.quantity,
          properties: properties
        });
      })
      .then(function () {
        var ids = c.accessoryIdsFromState(state);
        if (window.SuecoGiftSync) {
          window.SuecoGiftSync.forget(ids);
          return window.SuecoGiftSync.syncNow();
        }
        return null;
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        console.error("[cart-gift-editor] save failed:", err);
        showError(el, err.message || "保存に失敗しました。もう一度お試しください。");
        setBusy(el, false);
      });
  }

  function findLine(cart, key, index) {
    var items = cart.items || [];
    var byKey = items.filter(function (item) {
      return item.key === key;
    });
    if (byKey.length) return byKey[0];
    var position = parseInt(index, 10);
    return position && items[position - 1] ? items[position - 1] : null;
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function postChange(payload) {
    var headers = { "Content-Type": "application/json" };
    // 自前で syncNow を呼ぶので、cart-gift-sync の自動同期とは競合させない
    headers[SYNC_HEADER] = "1";

    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: headers,
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (response.ok) return response.json();
      return response.json().then(
        function (err) {
          throw new Error(
            err && err.description ? err.description : "カートの更新に失敗しました"
          );
        },
        function () {
          throw new Error("カートの更新に失敗しました");
        }
      );
    });
  }

  // cart.js は数量変更のたびに .js-contents を差し替えるため、
  // 新しく描画された行にも自動で組み直す。
  function observeCart() {
    var root = document.getElementById("main-cart-items");
    if (!root || typeof MutationObserver === "undefined") return;
    var timer = null;
    new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(initAll, 50);
    }).observe(root, { childList: true, subtree: true });
  }

  function boot() {
    initAll();
    observeCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // セクション再描画のあとに呼べるようにしておく
  window.SuecoCartGiftEditor = { init: initAll };
})();
